// extracted by mini-css-extract-plugin
export default {"client-profile":"client-profile_client-profile__H-VTQ","client-profile-icon":"client-profile_client-profile-icon__hlkC8","profile-text":"client-profile_profile-text__j7CwR"};